import React from "react";
import CTALink from "@/components/CTA/ctaLink";
import { hyphenateForTagular } from "@/utils/tagular/helpers";
import useTranslations from "@/i18n/useTranslations";

type Props = {
  productName: string;
  variant?: "default" | "compact";
};

const CTAButton = ({ productName }: { productName: string }) => {
  const t = useTranslations("Course");
  return (
    <CTALink
      label={t("requestMoreInfo")}
      url="https://business.edx.org/business/book-demo?utm_medium=WebReferral&utm_source=edX&utm_campaign=edXCoursePage"
      size="lg"
      location="enterprise-solutions-asset"
      html_id="request-info-CTA"
      name={hyphenateForTagular(productName)}
      type="brand"
      className="py-2.5 px-6 w-full sm:w-auto font-normal"
    />
  );
};

function EnterpriseCTA({ productName, variant = "default" }: Props) {
  const t = useTranslations("Course");
  return variant === "default" ? (
    <div className="bg-putty-300 py-14 px-4 sm:px-[200px] items-center flex flex-col gap-8">
      <div className="flex flex-col gap-4 text-center">
        <h2 className="font-inter font-black italic text-4xl sm:text-6xl text-primary-500 mb-0 mt-0">
          {t("interestedInCourseBusinessTeam")}
        </h2>
        <p className="font-inter text-base text-gray-800 mb-0">
          {t("trainEmployeesEdxBusiness")}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <CTAButton productName={productName} />
      </div>
    </div>
  ) : (
    <div className="bg-putty-300 py-6">
      <div className="flex flex-col md:flex-row gap-4 text-center items-center justify-center max-w-4xl mx-auto px-4">
        <h2 className="font-inter font-bold text-xl text-primary-500 my-0">
          {t("interestedInCourseTeam")}
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <CTAButton productName={productName} />
        </div>
      </div>
    </div>
  );
}

export default EnterpriseCTA;
